import type { FC, ReactNode } from 'react';
import type { Theme } from '@mui/material';
import { experimentalStyled } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

export type LabelColor = 'primary' | 'secondary' | 'error' | 'warning' | 'success';

interface TextLabelProps {
  children?: ReactNode;
  style?: {};
  sx?: SxProps<Theme>;
}

interface LabelRootProps {
}

const TextLabelRoot = experimentalStyled('span')<LabelRootProps>(({ theme }) => {

  return {
    alignItems: 'center',
    //backgroundColor: '#EEE',
    borderRadius: '3px',
    color: 'black',
    cursor: 'default',
    display: 'inline-block',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: 'Helvetica,Arial,sans-serif',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    justifyContent: 'center',
    letterSpacing: 0.5,
    minWidth: 20,
    paddingBottom: theme.spacing(0.6),
    //paddingLeft: theme.spacing(1),
    //paddingRight: theme.spacing(4),
    //paddingTop: theme.spacing(0.7),
    marginLeft: theme.spacing(0.2),
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    width: '99.85%'
  };
});

const TextLabel: FC<React.PropsWithChildren<TextLabelProps>> = (props) => {
  const {children, ...other } = props;
  return (
    <TextLabelRoot {...other}>
      {children}
    </TextLabelRoot>
  );
};

export default TextLabel;
